//------------- COMPONENT MENU LATERAL ---------

//barra de menu lateral pertencente a todas as páginas do portal
//onde estão os botões de página

//aqui será necessário alterar o url redirecionado dos botões:
// - planos
// - checklists
// - indicadores
//quando estas páginas forem finalizadas
//por enquanto, estão enviando ao Login

//apague esses comentarios quando terminar as tarefas kkkkkk

//importações
import React from "react";
import { useState } from "react";
import "./styles.css";

import { Link } from "react-router-dom";

//icons
import { TiHomeOutline } from "react-icons/ti";
import { BsCalendarWeek, BsMap, BsPlus, BsFillCalendarCheckFill } from "react-icons/bs";
import { FaRoute } from "react-icons/fa";
import { FaRegClipboard } from "react-icons/fa";
import { VscChecklist } from "react-icons/vsc";
import { VscPieChart } from "react-icons/vsc";

//component
//page recebe a página atual para gerenciar o estilo do botão
const MenuLateral = ({ page, setPage }) => {
    const [onHover, setOnHover] = useState(false);

    //aqui são inseridos botões no menu lateral
    //importe o icone para inseri-lo aqui
    const pageList = [
        {
            nome: "Início",
            rota: "/home",
            icone: <TiHomeOutline className="icon"></TiHomeOutline>,
        },
        {
            nome: "Agenda",
            rota: "/agenda",
            icone: <BsCalendarWeek className="icon"></BsCalendarWeek>,
        },
        {
            nome: "Criar Rota",
            rota: "/agenda/rotas",
            icone: <BsPlus className="icon"></BsPlus>,
        },
        // {
        //     nome: "Rotas",
        //     rota: "/agenda/rotas",
        //     icone: <FaRoute className="icon"></FaRoute>,
        // },
        {
            nome: "Mapa",
            rota: "/mapa",
            // rota: "/planos",
            icone: <BsMap className="icon"></BsMap>,
        },
        // {
        //     nome: "Realizados",
        //     rota: "/",
        //     // rota: "/checklists",
        //     icone: <VscChecklist className="icon"></VscChecklist>,
        // },
        {
            nome: "Indicadores",
            rota: "/indicadores",
            // rota: "/indicadores",
            icone: <VscPieChart className="icon"></VscPieChart>,
        },
        {
            nome: "Realizados",
            rota: "/realizados",
            // rota: "/indicadores",
            icone:  <BsFillCalendarCheckFill className="icon"></BsFillCalendarCheckFill>,
        },
    ];

    //view do component
    return (
        <div
            className="div-lateral"
            onMouseEnter={() => setOnHover(true)}
            onMouseLeave={() => setOnHover(false)}
        >
            <div className="div-logo">
                <p className="login-logo-inspe-lateral">iNspe</p>
            </div>
            <div className="div-buttons">
                {pageList.map((element, i) => {
                    return (
                        <Link
                            key={"btnLateral-" + i}
                            className={page === element.rota ? "btn-page-selected" : "btn-page"}
                            to={element.rota}
                            onClick={() => {
                                setPage(element.rota);
                            }}
                        >
                            {element.icone}
                            {onHover && <p>{element.nome}</p>}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default MenuLateral;
